(() => {
  const section = document.querySelector('[data-weightlist]');
  if (!section) return;

  const track = section.querySelector('.weightlist__track');
  const steps = [...section.querySelectorAll('[data-wl-step]')];
  if (!track || !steps.length) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const clamp01 = (v) => Math.max(0, Math.min(1, v));
  const smoothstep = (t) => {
    const x = clamp01(t);
    return x * x * (3 - 2 * x);
  };

  // Short crossfade at step boundaries; each line holds full opacity between them.
  const CROSSFADE = 0.32;
  // Last portion of the track holds the email form.
  const FINALE_HOLD = 0.18;

  let raf = null;
  let activeIndex = -1;

  function progress() {
    const rect = track.getBoundingClientRect();
    const range = rect.height - window.innerHeight;
    if (range <= 0) return 0;
    return clamp01(-rect.top / range);
  }

  function stepPosition(p) {
    const last = steps.length - 1;
    if (last <= 0) return 0;
    const rantEnd = 1 - FINALE_HOLD;
    if (p >= rantEnd) return last;
    return (p / rantEnd) * last;
  }

  function opacityForStep(index, pos) {
    const d = pos - index;

    if (d >= 0 && d < 1 - CROSSFADE) return 1;
    if (d >= 1 - CROSSFADE && d < 1) {
      return 1 - smoothstep((d - (1 - CROSSFADE)) / CROSSFADE);
    }
    if (d >= -CROSSFADE && d < 0) {
      return smoothstep((d + CROSSFADE) / CROSSFADE);
    }
    return 0;
  }

  function render() {
    if (reduceMotion.matches) {
      steps.forEach((el) => {
        el.style.opacity = '1';
        el.style.transform = 'none';
        el.classList.add('is-active');
      });
      section.classList.add('is-finale');
      return;
    }

    const p = progress();
    const pos = stepPosition(p);
    const last = steps.length - 1;
    let nextActive = -1;
    let best = -1;
    let bestScore = -1;

    steps.forEach((el, i) => {
      const opacity = opacityForStep(i, pos);
      const dir = pos - i;
      const y = (1 - opacity) * (dir < 0 ? 28 : -18);

      el.style.opacity = opacity.toFixed(3);
      el.style.transform = `translateY(${y.toFixed(1)}px)`;
      el.classList.toggle('is-shown', opacity > 0.02);
      el.setAttribute('aria-hidden', opacity < 0.2 ? 'true' : 'false');

      if (opacity > bestScore) {
        bestScore = opacity;
        best = i;
      }
    });

    steps.forEach((el, i) => {
      const isActive = i === best && bestScore > 0.25;
      el.classList.toggle('is-active', isActive);
      if (isActive) nextActive = i;
    });

    if (nextActive !== activeIndex) {
      activeIndex = nextActive;
      section.classList.toggle('is-finale', activeIndex === last);
    }
  }

  function onScroll() {
    if (raf) return;
    raf = requestAnimationFrame(() => {
      raf = null;
      render();
    });
  }

  render();

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
})();
